/** @jsx builderX.jsx */
import { builderX, Sprite } from '@gongxigames/framework/core/fragments/BuilderX';

export default <Sprite name='reels'>
    <Sprite position={[492, 312]} name='reel0'>
        <Sprite name='sym0'/>
        <Sprite position={[0, 480]} name='sym1'/>
        <Sprite position={[0, 960]} name='sym2'/>
    </Sprite>
    <Sprite position={[1068, 312]} name='reel1'>
        <Sprite name='sym0'/>
        <Sprite position={[0, 480]} name='sym1'/>
        <Sprite position={[0, 960]} name='sym2'/>
    </Sprite>
    <Sprite position={[1644, 312]} name='reel2'>
        <Sprite name='sym0'/>
        <Sprite position={[0, 480]} name='sym1'/>
        <Sprite position={[0, 960]} name='sym2'/>
    </Sprite>
    <Sprite position={[2220, 312]} name='reel3'>
        <Sprite name='sym0'/>
        <Sprite position={[0, 480]} name='sym1'/>
        <Sprite position={[0, 960]} name='sym2'/>
    </Sprite>
    <Sprite position={[2796, 312]} name='reel4'>
        <Sprite name='sym0'/>
        <Sprite position={[0, 480]} name='sym1'/>
        <Sprite position={[0, 960]} name='sym2'/>
    </Sprite>
</Sprite>;
